// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../rescript/lib/es6/curry.js";
import * as Json__Decode from "../../../../rescript-json/lib/es6_global/src/Json__Decode.bs.js";
import * as Json__Encode from "../../../../rescript-json/lib/es6_global/src/Json__Encode.bs.js";
import * as Generic$ApiTypes from "./utils/Generic.bs.js";
import * as ProductRuleConfigId$ApiTypes from "./ProductRuleConfigId.bs.js";

function toJson(stringCondition) {
  switch (stringCondition.TAG | 0) {
    case /* EqualsTo */0 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(stringCondition._0, "EqualsTo", Generic$ApiTypes.Encode.string);
    case /* Contains */1 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(stringCondition._0, "Contains", Generic$ApiTypes.Encode.string);
    case /* NotEqualsTo */2 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(stringCondition._0, "NotEqualsTo", Generic$ApiTypes.Encode.string);
    
  }
}

var fromJson = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("EqualsTo", Generic$ApiTypes.Decode.string, (function (payload) {
            return {
                    TAG: /* EqualsTo */0,
                    _0: payload
                  };
          })), [
      Generic$ApiTypes.Decode.deccoVariantWithPayload("Contains", Generic$ApiTypes.Decode.string, (function (payload) {
              return {
                      TAG: /* Contains */1,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("NotEqualsTo", Generic$ApiTypes.Decode.string, (function (payload) {
              return {
                      TAG: /* NotEqualsTo */2,
                      _0: payload
                    };
            }))
    ]);

var StringCondition = {
  toJson: toJson,
  fromJson: fromJson
};

function toJson$1(t) {
  switch (t.TAG | 0) {
    case /* EqualsTo */0 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "EqualsTo", Generic$ApiTypes.Encode.$$float);
    case /* NotEqualsTo */1 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "NotEqualsTo", Generic$ApiTypes.Encode.$$float);
    case /* GreaterThan */2 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "GreaterThan", Generic$ApiTypes.Encode.$$float);
    case /* GreaterThanOrEqualsTo */3 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "GreaterThanOrEqualsTo", Generic$ApiTypes.Encode.$$float);
    case /* LessThan */4 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "LessThan", Generic$ApiTypes.Encode.$$float);
    case /* LessThanOrEqualsTo */5 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "LessThanOrEqualsTo", Generic$ApiTypes.Encode.$$float);
    
  }
}

var fromJson$1 = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("EqualsTo", Generic$ApiTypes.Decode.$$float, (function (payload) {
            return {
                    TAG: /* EqualsTo */0,
                    _0: payload
                  };
          })), [
      Generic$ApiTypes.Decode.deccoVariantWithPayload("NotEqualsTo", Generic$ApiTypes.Decode.$$float, (function (payload) {
              return {
                      TAG: /* NotEqualsTo */1,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("GreaterThan", Generic$ApiTypes.Decode.$$float, (function (payload) {
              return {
                      TAG: /* GreaterThan */2,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("GreaterThanOrEqualsTo", Generic$ApiTypes.Decode.$$float, (function (payload) {
              return {
                      TAG: /* GreaterThanOrEqualsTo */3,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("LessThan", Generic$ApiTypes.Decode.$$float, (function (payload) {
              return {
                      TAG: /* LessThan */4,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("LessThanOrEqualsTo", Generic$ApiTypes.Decode.$$float, (function (payload) {
              return {
                      TAG: /* LessThanOrEqualsTo */5,
                      _0: payload
                    };
            }))
    ]);

var FloatCondition = {
  toJson: toJson$1,
  fromJson: fromJson$1
};

function toJson$2(t) {
  switch (t.TAG | 0) {
    case /* EqualsTo */0 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "EqualsTo", Generic$ApiTypes.Encode.$$int);
    case /* NotEqualsTo */1 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "NotEqualsTo", Generic$ApiTypes.Encode.$$int);
    case /* GreaterThan */2 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "GreaterThan", Generic$ApiTypes.Encode.$$int);
    case /* GreaterThanOrEqualsTo */3 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "GreaterThanOrEqualsTo", Generic$ApiTypes.Encode.$$int);
    case /* LessThan */4 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "LessThan", Generic$ApiTypes.Encode.$$int);
    case /* LessThanOrEqualsTo */5 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "LessThanOrEqualsTo", Generic$ApiTypes.Encode.$$int);
    
  }
}

var fromJson$2 = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("EqualsTo", Generic$ApiTypes.Decode.$$int, (function (payload) {
            return {
                    TAG: /* EqualsTo */0,
                    _0: payload
                  };
          })), [
      Generic$ApiTypes.Decode.deccoVariantWithPayload("NotEqualsTo", Generic$ApiTypes.Decode.$$int, (function (payload) {
              return {
                      TAG: /* NotEqualsTo */1,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("GreaterThan", Generic$ApiTypes.Decode.$$int, (function (payload) {
              return {
                      TAG: /* GreaterThan */2,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("GreaterThanOrEqualsTo", Generic$ApiTypes.Decode.$$int, (function (payload) {
              return {
                      TAG: /* GreaterThanOrEqualsTo */3,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("LessThan", Generic$ApiTypes.Decode.$$int, (function (payload) {
              return {
                      TAG: /* LessThan */4,
                      _0: payload
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("LessThanOrEqualsTo", Generic$ApiTypes.Decode.$$int, (function (payload) {
              return {
                      TAG: /* LessThanOrEqualsTo */5,
                      _0: payload
                    };
            }))
    ]);

var IntCondition = {
  toJson: toJson$2,
  fromJson: fromJson$2
};

function toJson$3(arrayCondition, payloadEncoder) {
  if (arrayCondition.TAG === /* Any */0) {
    return Generic$ApiTypes.Encode.deccoVariantWithPayload(arrayCondition._0, "Any", payloadEncoder);
  } else {
    return Generic$ApiTypes.Encode.deccoVariantWithPayload(arrayCondition._0, "NotAny", payloadEncoder);
  }
}

function fromJson$3(payloadDecoder) {
  return Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("Any", payloadDecoder, (function (payload) {
                    return {
                            TAG: /* Any */0,
                            _0: payload
                          };
                  })), [Generic$ApiTypes.Decode.deccoVariantWithPayload("NotAny", payloadDecoder, (function (payload) {
                      return {
                              TAG: /* NotAny */1,
                              _0: payload
                            };
                    }))]);
}

var ArrayCondition = {
  toJson: toJson$3,
  fromJson: fromJson$3
};

function toJson$4(param) {
  return Json__Encode.object([
              [
                "id",
                Curry._1(ProductRuleConfigId$ApiTypes.toJson, param.id)
              ],
              [
                "condition",
                toJson$3(param.condition, toJson)
              ]
            ]);
}

var fromJson$4 = Json__Decode.map2(Json__Decode.field("id", ProductRuleConfigId$ApiTypes.fromJson), Json__Decode.field("condition", fromJson$3(fromJson)), (function (id, condition) {
        return {
                id: id,
                condition: condition
              };
      }));

var ProductTags = {
  toJson: toJson$4,
  fromJson: fromJson$4
};

function toJson$5(param) {
  return Json__Encode.object([
              [
                "id",
                Curry._1(ProductRuleConfigId$ApiTypes.toJson, param.id)
              ],
              [
                "condition",
                toJson(param.condition)
              ]
            ]);
}

var fromJson$5 = Json__Decode.map2(Json__Decode.field("id", ProductRuleConfigId$ApiTypes.fromJson), Json__Decode.field("condition", fromJson), (function (id, condition) {
        return {
                id: id,
                condition: condition
              };
      }));

var ProductType = {
  toJson: toJson$5,
  fromJson: fromJson$5
};

function toJson$6(param) {
  return Json__Encode.object([
              [
                "id",
                Curry._1(ProductRuleConfigId$ApiTypes.toJson, param.id)
              ],
              [
                "condition",
                toJson$3(param.condition, toJson)
              ]
            ]);
}

var fromJson$6 = Json__Decode.map2(Json__Decode.field("id", ProductRuleConfigId$ApiTypes.fromJson), Json__Decode.field("condition", fromJson$3(fromJson)), (function (id, condition) {
        return {
                id: id,
                condition: condition
              };
      }));

var CustomLabels = {
  toJson: toJson$6,
  fromJson: fromJson$6
};

function toJson$7(param) {
  return Json__Encode.object([
              [
                "id",
                Curry._1(ProductRuleConfigId$ApiTypes.toJson, param.id)
              ],
              [
                "metadataKey",
                Json__Encode.string(param.metadataKey)
              ],
              [
                "condition",
                toJson(param.condition)
              ]
            ]);
}

var fromJson$7 = Json__Decode.map3(Json__Decode.field("id", ProductRuleConfigId$ApiTypes.fromJson), Json__Decode.field("metadataKey", Json__Decode.string), Json__Decode.field("condition", fromJson), (function (id, metadataKey, condition) {
        return {
                id: id,
                metadataKey: metadataKey,
                condition: condition
              };
      }));

var ProductMetaData = {
  toJson: toJson$7,
  fromJson: fromJson$7
};

function toJson$8(param) {
  return Json__Encode.object([
              [
                "id",
                Curry._1(ProductRuleConfigId$ApiTypes.toJson, param.id)
              ],
              [
                "condition",
                toJson$1(param.condition)
              ]
            ]);
}

var fromJson$8 = Json__Decode.map2(Json__Decode.field("id", ProductRuleConfigId$ApiTypes.fromJson), Json__Decode.field("condition", fromJson$1), (function (id, condition) {
        return {
                id: id,
                condition: condition
              };
      }));

var ProductPrice = {
  toJson: toJson$8,
  fromJson: fromJson$8
};

function toJson$9(param) {
  return Json__Encode.object([
              [
                "id",
                Curry._1(ProductRuleConfigId$ApiTypes.toJson, param.id)
              ],
              [
                "condition",
                toJson$2(param.condition)
              ]
            ]);
}

var fromJson$9 = Json__Decode.map2(Json__Decode.field("id", ProductRuleConfigId$ApiTypes.fromJson), Json__Decode.field("condition", fromJson$2), (function (id, condition) {
        return {
                id: id,
                condition: condition
              };
      }));

var ProductQuantity = {
  toJson: toJson$9,
  fromJson: fromJson$9
};

function toJson$10(op) {
  return Generic$ApiTypes.Encode.simpleVariant([
              [
                "And",
                /* And */0
              ],
              [
                "Or",
                /* Or */1
              ]
            ], op);
}

var fromJson$10 = Generic$ApiTypes.Decode.simpleVariant([
      [
        "And",
        /* And */0
      ],
      [
        "Or",
        /* Or */1
      ]
    ]);

var Op = {
  toJson: toJson$10,
  fromJson: fromJson$10
};

function toJson$11(encoder, param) {
  return Curry._1(Generic$ApiTypes.Encode.object, [
              [
                "id",
                Curry._1(ProductRuleConfigId$ApiTypes.toJson, param.id)
              ],
              [
                "rules",
                Curry._2(Generic$ApiTypes.Encode.array, param.rules, encoder)
              ],
              [
                "op",
                toJson$10(param.op)
              ]
            ]);
}

function fromJson$11(decoder) {
  return Curry._4(Generic$ApiTypes.Decode.map3, Curry._2(Generic$ApiTypes.Decode.field, "id", ProductRuleConfigId$ApiTypes.fromJson), Curry._2(Generic$ApiTypes.Decode.field, "rules", Curry._1(Generic$ApiTypes.Decode.array, Generic$ApiTypes.Decode.lazy_(decoder))), Curry._2(Generic$ApiTypes.Decode.field, "op", fromJson$10), (function (id, rules, op) {
                return {
                        id: id,
                        op: op,
                        rules: rules
                      };
              }));
}

var CompoundRule = {
  toJson: toJson$11,
  fromJson: fromJson$11
};

function toJson$12(t) {
  switch (t.TAG | 0) {
    case /* ProductTags */0 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "ProductTags", toJson$4);
    case /* ProductType */1 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "ProductType", toJson$5);
    case /* CustomLabels */2 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "CustomLabels", toJson$6);
    case /* ProductMetaData */3 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "ProductMetaData", toJson$7);
    case /* ProductPrice */4 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "ProductPrice", toJson$8);
    case /* ProductQuantity */5 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "ProductQuantity", toJson$9);
    case /* CompoundRule */6 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "CompoundRule", (function (param) {
                      return toJson$11(toJson$12, param);
                    }));
    
  }
}

function fromJson$12(param) {
  return Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("ProductTags", fromJson$4, (function (payload) {
                    return {
                            TAG: /* ProductTags */0,
                            _0: payload
                          };
                  })), [
              Generic$ApiTypes.Decode.deccoVariantWithPayload("ProductType", fromJson$5, (function (payload) {
                      return {
                              TAG: /* ProductType */1,
                              _0: payload
                            };
                    })),
              Generic$ApiTypes.Decode.deccoVariantWithPayload("CustomLabels", fromJson$6, (function (payload) {
                      return {
                              TAG: /* CustomLabels */2,
                              _0: payload
                            };
                    })),
              Generic$ApiTypes.Decode.deccoVariantWithPayload("ProductMetaData", fromJson$7, (function (payload) {
                      return {
                              TAG: /* ProductMetaData */3,
                              _0: payload
                            };
                    })),
              Generic$ApiTypes.Decode.deccoVariantWithPayload("ProductPrice", fromJson$8, (function (payload) {
                      return {
                              TAG: /* ProductPrice */4,
                              _0: payload
                            };
                    })),
              Generic$ApiTypes.Decode.deccoVariantWithPayload("ProductQuantity", fromJson$9, (function (payload) {
                      return {
                              TAG: /* ProductQuantity */5,
                              _0: payload
                            };
                    })),
              Generic$ApiTypes.Decode.deccoVariantWithPayload("CompoundRule", fromJson$11(fromJson$12), (function (payload) {
                      return {
                              TAG: /* CompoundRule */6,
                              _0: payload
                            };
                    }))
            ]);
}

export {
  StringCondition ,
  FloatCondition ,
  IntCondition ,
  ArrayCondition ,
  ProductTags ,
  ProductType ,
  CustomLabels ,
  ProductMetaData ,
  ProductPrice ,
  ProductQuantity ,
  Op ,
  CompoundRule ,
  toJson$12 as toJson,
  fromJson$12 as fromJson,
}
/* fromJson Not a pure module */
